/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { SortableArrayField, ContentModuleModal, TextField } from '@molecules';
import { NO_MARGIN_BOTTOM } from '@constants';

import Form from '../Form';

import AddVideoForm from './AddVideoPanelForm';
import Item from './item';
import VideoItem from './VideoPanelItem';
import { MODULE_FIELDS } from './constant';

const VideoDisplayPanel = ({ visible = true, onSubmit, hide, previewImg, onDelete, initialValues, errors }) => {
  const [form] = Form.useForm(MODULE_FIELDS);

  const handleClose = () => {
    form.resetFields();
    hide();
  };

  const handleSubmit = (values) => {
    onSubmit(values);
    handleClose();
  };

  const handleAdd = React.useCallback(
    (slide) => {
      form.setFields([
        {
          name: MODULE_FIELDS.VIDEOS.name,
          value: [slide, ...(form.getFieldValue(MODULE_FIELDS.VIDEOS.name) || [])],
        },
      ]);
    },
    [form],
  );
  return (
    <ContentModuleModal
      visible={visible}
      title="Inside Track Tokyo 2020"
      subtitle={
        <>
          Add videos to appear in a video panel.
          <br />
          You can add maximum 8 videos
        </>
      }
      okText={onDelete ? 'SAVE CHANGES' : 'ADD VIDEO PANEL'}
      onCancel={handleClose}
      onSubmit={form.submit}
      onDelete={onDelete}
      heroImageSrc={previewImg}
      errors={errors}
    >
      <AddVideoForm onSubmit={handleAdd} visible={visible} />
      <Form
        form={form}
        onSerializedFinish={handleSubmit}
        hideRequiredMark
        initialValues={initialValues}
        layout="vertical"
      >
        <SortableArrayField withPlaceholder withCount form={form} {...MODULE_FIELDS.VIDEOS}>
          {(video) => <VideoItem video={video} />}
        </SortableArrayField>
        <div style={{ borderTop: '1px solid #808080', marginLeft: -40, marginRight: -40 }} />
        <div style={{ marginTop: 30 }}>
          <TextField {...MODULE_FIELDS.TITLE} />
          <TextField {...MODULE_FIELDS.DESCRIPTION} style={NO_MARGIN_BOTTOM} />
        </div>
      </Form>
    </ContentModuleModal>
  );
};

VideoDisplayPanel.Item = Item;

export default VideoDisplayPanel;
